<template>
    <div class="coupon coupon-sample bg-color-secondary">
        <div>
            <div class="coupon-body text-center">
                <header class="fs-44 text-bold">
                    Wybrany produkt
                </header>
                <div v-if="!sample.freeSample">
                    <p 
                        v-bastards
                        class="fs-20 fs-lh-24"
                    >
                        Przykro nam, ale pula wybranej przez Ciebie próbki właśnie się wyczerpała. W zamian proponujemy <strong>kupon rabatowy o wartości 10%</strong> na ten produkt.
                    </p>
                </div>
            </div> 
            <div class="coupon-image">
                <ImageLazy 
                    v-if="sample.freeSample"
                    :image-url="samplingArticle.image"
                    :height="353"
                />
                <ImageLazy 
                    v-else-if="sample.image"
                    :image-url="sample.image"
                    :height="353"
                />
            </div>
            <div 
                v-if="!sample.freeSample" 
                class="coupon-body coupon-body--extract text-center"
            >
                <p 
                    v-bastards
                    class="fs-17 text-bold"
                >
                    Kupon wysłaliśmy na Twój adres e-mail.
                </p>
            </div>
            <div 
                v-else
                class="coupon-body coupon-body--extract text-center"
            >
                <p 
                    v-bastards
                    class="fs-20 fs-lh-24"
                >
                    Informacja, jak odebrać ten produkt, zostanie wysłana na Twój adres e-mail po zakończeniu akcji promocyjnej.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sample: {
            type: Object,
            required: false,
            default: () => {}
        }
    },

    computed: {
        samplingArticle() {
            return this.$store.getters['apiCampaign/samplingArticle'](this.$store.getters['apiSample/selectedSampleId'])
        }
    },

    mounted() {
        console.log(this.sample)
    }
}
</script>

<style lang="scss">
.coupon-sample {
    .coupon-body {
        padding: 0 70px;

        &--extract {
            padding-top: 30px;
            padding-bottom: 30px;
        }

        header {
            padding: 44px 0 13px;
        }

        p + p {
            padding: 30px 0 0;
        }

        p { 
            strong {
                font-weight: $font-weight-bold;
            }
        }
    }

    .coupon-image {
        padding: 34px 0 0;
        text-align: center;
    }
}
</style>
